import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { formatHoursRange } from '@/lib/schedule'
import { OPENING_HOURS } from '@/constants/business'

interface HoursListProps {
    className?: string
}

// Weekly opening hours with today's row highlighted once the visitor's clock is known.
export const HoursList: FC<HoursListProps> = ({ className }): ReactNode => {
    const [today, setToday] = useState<number | null>(null)

    useEffect(() => {
        setToday(new Date().getDay())
    }, [])

    return (
        <dl className={cn('space-y-1', className)}>
            {OPENING_HOURS.map(entry => {
                const isToday = entry.day === today

                return (
                    <div
                        key={entry.day}
                        className={cn(
                            'flex items-center justify-between gap-4 rounded-xl px-4 py-2.5 text-[0.95rem]',
                            isToday && 'bg-foam ring-1 ring-aqua/40'
                        )}
                    >
                        <dt className={cn('flex items-center gap-2', isToday ? 'font-bold text-ink' : 'text-muted-foreground')}>
                            {entry.name}

                            {isToday && (
                                <span className='rounded-full bg-aqua px-2 py-0.5 text-[0.65rem] font-bold uppercase tracking-wider text-ink'>
                                    Today
                                </span>
                            )}
                        </dt>

                        <dd className={cn('tabular-nums text-ink', isToday ? 'font-bold' : 'font-medium')}>
                            {formatHoursRange(entry)}
                        </dd>
                    </div>
                )
            })}
        </dl>
    )
}
